import React from 'react';
import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import type { EDIT_MODE, VIEW_MODE } from '../../../constants';
import { ExplanationContainer } from '../../styled';
import messages from './messages';

type Props = {
	mode: typeof EDIT_MODE | typeof VIEW_MODE;
};

const SlaDisplayFormatTitleComponent = ({ mode }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Heading size="xsmall" as="h2">
				<Box>{formatMessage(messages.displayFormatHeader)}</Box>
			</Heading>
			{mode === 'edit' && (
				<ExplanationContainer>
					{formatMessage(messages.displayFormatHeaderExplaination)}
				</ExplanationContainer>
			)}
		</>
	);
};

export const SlaDisplayFormatTitle = SlaDisplayFormatTitleComponent;
